import { gql } from "react-apollo";

export const USER_PROFILE = gql`
  query {
    data: userProfile {
      companyName
      user {
        id
        firstName
        username
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/landing/gql/query.js